/**
 * ModalProgressBar
 *
 * Progress indicator for multi-step modal flows (onboarding, signup, etc.)
 * Shows animated progress bar + "X of Y" text
 */
"use client";

import { motion } from "framer-motion";

interface ModalProgressBarProps {
  currentStep: number;
  totalSteps: number;
  /** If true, animates from previous step width (for step transitions) */
  animateFromPrevious?: boolean;
}

export function ModalProgressBar({
  currentStep,
  totalSteps,
  animateFromPrevious = false,
}: ModalProgressBarProps) {
  return (
    <div className="absolute left-4 right-4 top-4 sm:left-8 sm:right-[45px]">
      <div className="flex flex-col gap-1">
        <div className="h-0.5 overflow-hidden rounded-full bg-gray-200">
          <motion.div
            className="h-full bg-black"
            initial={
              animateFromPrevious
                ? { width: `${((currentStep - 1) / totalSteps) * 100}%` }
                : { width: 0 }
            }
            animate={{
              width: `${(currentStep / totalSteps) * 100}%`,
            }}
            transition={{ duration: 0.3 }}
          />
        </div>
        <span className="text-input-modal text-ink-secondary" style={{ fontSize: "11px" }}>
          {currentStep} of {totalSteps}
        </span>
      </div>
    </div>
  );
}
